/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/11/3
 * @updateTime 2021/11/3
 * @decription 业务公共组件 =》 标题栏组件
 */
export default {
    name: 'ac-title-bar',
    // 混入
    mixins: [],
    // 依赖组件
    components: {},
    // 参数
    props: {
        // 标题
        title: {
            type: String
        }
    },
    // 数据
    data() {
        return {
            // 当前作用域变量
            scope: {
                // 类名前缀
                prefixCls: 'fd-cc-title-bar'
            }
        };
    },
    // 计算属性
    computed: {},
    // 监听
    watch: {},
    // 创建完成
    created() {
        // 创建完成
    },
    // 组件激活
    activated() {
        // 激活完成
    },
    // 组件初始化完成
    mounted() {
        // 初始化完成
    },
    // 组件失去激活
    deactivated() {
        // 失去激活
    },
    // 销毁之前
    beforeDestroy() {
        // 销毁之前
    },
    // 方法
    methods: {
        /**
         * 点击返回
         * @returns {void}
         * */
        eClickBack() {
            this.$emit('back');
        },
        /**
         * 跳转到首页
         * @returns {void}
         * */
        eClickGoHome() {
            this.$emit('go-home');
            // 跳转到首页
            this.$router.push('/home/index');
        }
    }
};
